export const SORT_OPTIONS = {
  ID: "id",
  "First Name": "first_name",
  "Last Name": "last_name",
  Username: "username",
  Email: "email",
  Client: "client_name",
  "Last Online": "last_online",
  Created: "created",
  "Completed Courses": "completed_courses",
  "In Progress Courses": "in_progress_courses",
}

export const ACCOUNT_CREATION_OPTIONS = {
  All: "all",
  "SSO: Github": "github_id",
  "SSO: Amazon": "amazon_id",
  "SSO: Facebook": "facebook_id",
  "SSO: Google": "google_id",
  "SSO: Meta Quest": "meta_quest_id",
  Email: "email",
}
